"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebviewProvider = void 0;
const transaction_1 = require("@multiversx/sdk-core/out/transaction");
const webviewProviderEventHandler_1 = require("./webviewProviderEventHandler");
const enums_1 = require("@multiversx/sdk-web-wallet-cross-window-provider/out/enums");
const windowProviderConstants_1 = require("@multiversx/sdk-web-wallet-cross-window-provider/out/constants/windowProviderConstants");
const getTargetOrigin_1 = require("./helpers/getTargetOrigin");
const getSafeWindow_1 = require("./helpers/getSafeWindow");
const getSafeDocument_1 = require("./helpers/getSafeDocument");
const sdk_core_1 = require("@multiversx/sdk-core");
const out_1 = require("@multiversx/sdk-core/out");
class WebviewProvider {
    static getInstance(options) {
        if (!WebviewProvider._instance) {
            WebviewProvider._instance = new WebviewProvider(options);
        }
        return WebviewProvider._instance;
    }
    constructor(options) {
        this.initialized = false;
        this.account = { address: '' };
        this.resetState = (resetStateCallback) => {
            var _a, _b;
            (_b = (_a = (0, getSafeWindow_1.getSafeWindow)()).addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'message', (0, webviewProviderEventHandler_1.webviewProviderEventHandler)(enums_1.WindowProviderResponseEnums.resetStateResponse, (data) => {
                if (data.type === enums_1.WindowProviderResponseEnums.resetStateResponse) {
                    resetStateCallback === null || resetStateCallback === void 0 ? void 0 : resetStateCallback();
                    setTimeout(() => {
                        this.finalizeResetState();
                    }, 500);
                }
            }));
        };
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            this.initialized = true;
            return this.initialized;
        });
        this.login = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.initialized) {
                throw new Error('Provider not initialized');
            }
            const response = yield this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.loginRequest,
                payload: undefined
            });
            if (response.type == enums_1.WindowProviderResponseEnums.cancelResponse) {
                console.warn('Cancelled the login action');
                yield this.cancelAction();
                return null;
            }
            if (!response.payload.data) {
                console.error('Error logging in', (_a = response.payload.error) !== null && _a !== void 0 ? _a : 'No data received');
                return null;
            }
            this.account = response.payload.data;
            return this.account;
        });
        this.logout = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.logoutRequest,
                payload: undefined
            });
            this.initialized = false;
            this.disconnect();
            return Boolean(response.payload.data);
        });
        this.relogin = () => __awaiter(this, void 0, void 0, function* () {
            var _b;
            const response = yield this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.reloginRequest,
                payload: undefined
            });
            if (response.type == enums_1.WindowProviderResponseEnums.cancelResponse) {
                console.warn('Cancelled the re-login action');
                yield this.cancelAction();
                return null;
            }
            if (!response.payload.data) {
                console.error('Re-login Error', (_b = response.payload.error) !== null && _b !== void 0 ? _b : 'No data received');
                return null;
            }
            const { data, error } = response.payload;
            if (error || !data) {
                throw new Error('Unable to re-login');
            }
            const { accessToken } = data;
            if (!accessToken) {
                console.error('Unable to re-login. Missing accessToken.');
                return null;
            }
            this.account.accessToken = accessToken;
            return accessToken;
        });
        this.signTransactions = (transactionsToSign) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.signTransactionsRequest,
                payload: transactionsToSign.map((tx) => tx.toPlainObject())
            });
            const { data: signedTransactions, error } = response.payload;
            if (error || !signedTransactions) {
                console.error('Unable to sign transactions');
                return null;
            }
            if (response.type == enums_1.WindowProviderResponseEnums.cancelResponse) {
                console.warn('Cancelled the transactions signing action');
                this.cancelAction();
                return null;
            }
            return signedTransactions.map((tx) => transaction_1.Transaction.fromPlainObject(tx));
        });
        this.signTransaction = (transaction) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.signTransactions([transaction]);
            return response === null || response === void 0 ? void 0 : response[0];
        });
        this.signMessage = (messageToSign) => __awaiter(this, void 0, void 0, function* () {
            var _c;
            const response = yield this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.signMessageRequest,
                payload: { message: Buffer.from(messageToSign.data).toString() }
            });
            const { data, error } = response.payload;
            if (error || !data) {
                console.error('Unable to sign message');
                return null;
            }
            if (response.type == enums_1.WindowProviderResponseEnums.cancelResponse) {
                console.warn('Cancelled the message signing action');
                this.cancelAction();
                return null;
            }
            if (data.status !== enums_1.SignMessageStatusEnum.signed) {
                console.error('Could not sign message');
                return null;
            }
            return new sdk_core_1.Message({
                data: Buffer.from(messageToSign.data),
                address: (_c = messageToSign.address) !== null && _c !== void 0 ? _c : out_1.Address.fromBech32(this.account.address),
                signer: 'webview',
                version: messageToSign.version,
                signature: Buffer.from(String(data.signature), 'hex')
            });
        });
        this.cancelAction = () => __awaiter(this, void 0, void 0, function* () {
            return this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.cancelAction,
                payload: undefined
            });
        });
        this.finalizeResetState = () => __awaiter(this, void 0, void 0, function* () {
            return this.sendPostMessage({
                type: enums_1.WindowProviderRequestEnums.finalizeResetStateRequest,
                payload: undefined
            });
        });
        this.sendPostMessage = (message) => __awaiter(this, void 0, void 0, function* () {
            var _d, _e;
            const safeWindow = (0, getSafeWindow_1.getSafeWindow)();
            if (safeWindow.ReactNativeWebView) {
                safeWindow.ReactNativeWebView.postMessage(JSON.stringify(message));
            }
            else if (safeWindow.webkit) {
                (_e = (_d = safeWindow.webkit.messageHandlers) === null || _d === void 0 ? void 0 : _d.jsHandler) === null || _e === void 0 ? void 0 : _e.postMessage(JSON.stringify(message), (0, getTargetOrigin_1.getTargetOrigin)());
            }
            else if (safeWindow.parent) {
                safeWindow.parent.postMessage(message, (0, getTargetOrigin_1.getTargetOrigin)());
            }
            return yield this.waitingForResponse(windowProviderConstants_1.responseTypeMap[message.type]);
        });
        this.waitingForResponse = (action) => __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve) => {
                var _a, _b, _c, _d;
                (_b = (_a = (0, getSafeWindow_1.getSafeWindow)()).addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, 'message', (0, webviewProviderEventHandler_1.webviewProviderEventHandler)(action, resolve));
                (_d = (_c = (0, getSafeDocument_1.getSafeDocument)()).addEventListener) === null || _d === void 0 ? void 0 : _d.call(_c, 'message', (0, webviewProviderEventHandler_1.webviewProviderEventHandler)(action, resolve));
            });
        });
        if (options === null || options === void 0 ? void 0 : options.resetStateCallback) {
            this.resetState(options.resetStateCallback);
        }
    }
    disconnect() {
        this.account = { address: '' };
    }
    isInitialized() {
        return this.initialized;
    }
    isConnected() {
        return Boolean(this.account.address);
    }
    getAccount() {
        return this.account;
    }
    setAccount(account) {
        this.account = account;
    }
}
exports.WebviewProvider = WebviewProvider;
//# sourceMappingURL=WebviewProvider.js.map